import React, {useEffect, useState} from 'react';
import "./onboard-connection-error-style.scss";
import {useRecoilValue} from "recoil";
import {connectionErrorAtom} from "../../../store/ConnectionErrorStore";
import {ReactComponent as IconError} from './images/completed-new-error-2.svg';
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import OnboardCountdown from "./OnboardCountdown";

const OnboardConnectionError = () => {

    const {t} = useTranslation();
    const connectionError = useRecoilValue(connectionErrorAtom);
    const [diagCheck, setDiagCheck] = useState(false);
    const location = useLocation();

    useEffect(() => {
        getDiagCheck();
        check();
    }, [connectionError]);

    useEffect(() => {
        getDiagCheck();
        check();
    }, [location]);

    const check = () => {
        if (connectionError) {
            const handleScroll = (e) => {
                e.preventDefault();
            };
            let divRef = document.getElementById("connectionErrorDialog");
            if (divRef !== null) {
                divRef.addEventListener('wheel', handleScroll);
                divRef.addEventListener('touchmove', handleScroll);
                return () => {
                    divRef.removeEventListener('wheel', handleScroll);
                    divRef.removeEventListener('touchmove', handleScroll);
                };
            }
        }
    }

    const getDiagCheck = () => {
        let pageName = window.location.hash.replace("#/", "");
        if (pageName.includes("/") > 0)
            pageName = pageName.split("/")[pageName.split("/").length - 1];
        if (pageName === 'diag' || pageName === 'DIAG') {
            setDiagCheck(true);
        } else setDiagCheck(false);
    }

    return (
        !diagCheck && connectionError && (<div id="connectionErrorDialog" className="onboard-connection-error-root">
            <div className="onboard-connection-error-back"></div>
            <div className="onboard-connection-error-text">
                <IconError className="onboard-connection-error-img"/>
                <div className="onboard-connection-error-img-tp">
                    <OnboardCountdown/>
                </div>
                <p className="onboard-connection-error-title">
                    {t('header_service.again')}
                </p>
                <p className="onboard-connection-error-content">
                    {t('header_service.error_message')}
                </p>
            </div>
        </div>)
    )
};

export default OnboardConnectionError;
